module.exports = __webpack_public_path__ + "static/media/noun-1198083-cc.0c8b4238.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/noun-1198083-cc.svg
// module id = 261
// module chunks = 0